import {useEffect, useState } from "react";
import { getAlertDetails } from "../../services/AppService";
import { useLocation, useNavigate } from "react-router-dom";
import PageFade from "../../components/Login/PageFade";
import closeButton from '../../assets/images/close.png';
import { useTranslation } from "react-i18next";


const AlertOverBudgetPage = () => {
    const {t}=useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const type = location.state?.type || "Over Budget";

    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [items, setItems] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [totalElements, setTotalElements] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchDetails();
    }, [page, size]);

    const fetchDetails = async () => {
        setLoading(true);
        try {
            const data = await getAlertDetails(type, page, size);
            setItems(data.content || []);
            setTotalPages(data.totalPages || 0);
            setTotalElements(data.totalElements || 0);
        } catch (err) {
            console.error("Error fetching alert details", err);
        } finally {
            setLoading(false);
        }
    };

    const handleViewPayments = (item) => {
        navigate("/smartcity/staff-alerts/over-budget/payment-details", {
            state: {
                budgetHeadId: item.id,
                budgetName: item.budgetName
            }
        });
    };

    return (
        <PageFade>
            <div className="bg-white shadow-lg rounded-2xl p-6">
                <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h4 className="text-xl font-semibold text-blue">{t('pageTitles.overBudgetDetails')}</h4>
                    <img
                        src={closeButton}
                        alt="Close"
                        className="w-6 h-6 cursor-pointer"
                        onClick={() => navigate(-1)}
                    />
                </div>

                <div className="overflow-x-auto">
                    <table className="w-full border text-sm rounded-lg">
                        <thead className="bg-[#a0adf1] text-white">
                            <tr>
                                <th className="px-3 py-2 border-b">{t('tables.srNo')}</th>
                                <th className="px-3 py-2 border-b">{t('accounts.payment.budgetName')}</th>
                                <th className="px-3 py-2 border-b">{t('accounts.payment.budgetAmount')} </th>
                                <th className="px-3 py-2 border-b">{t('accounts.payment.balanceAmount')}</th>
                                <th className="px-3 py-2 border-b">{t('accounts.payment.budgetDate')}</th>
                                <th className="px-3 py-2 border-b">{t('accounts.payment.viewPayments')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr><td colSpan="5" className="text-center py-4">Loading...</td></tr>
                            ) : items.length === 0 ? (
                                <tr><td colSpan="5" className="text-center py-4">No records found</td></tr>
                            ) : (
                                items.map((item, idx) => (
                                    <tr key={item.id} className={idx % 2 === 0 ? "bg-gray-50" : "bg-white"}>
                                        <td className="px-3 py-2 text-center">{page * size + idx + 1}</td>
                                        <td className="px-3 py-2">{item.budgetName}</td>
                                        <td className="px-3 py-2 text-center">{item.budgetAmount}</td>
                                        <td className="px-3 py-2 text-center">{item.balanceAmount}</td>
                                        <td className="px-3 py-2 text-center">{item.budgetDate}</td>
                                        <td className="px-3 py-2 text-center">
                                            <button
                                                onClick={() => handleViewPayments(item)}
                                                disabled={item.balanceAmount === 0}
                                                className="bg-blue-500 text-white px-3 py-1 rounded"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                <div className="flex justify-between items-center mt-4 text-sm">
                    <p>Showing {page * size + 1} to {page * size + items.length} of {totalElements}</p>
                    <div className="flex gap-1">
                        <button disabled={page === 0} onClick={() => setPage(p => p - 1)}>Previous</button>
                        {[...Array(totalPages)].map((_, i) => (
                            <button key={i} onClick={() => setPage(i)} className={page === i ? "bg-blue-500 text-white" : ""}>{i + 1}</button>
                        ))}
                        <button disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)}>Next</button>
                    </div>
                </div>
            </div>
        </PageFade>
    );
};

export default AlertOverBudgetPage;